import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Header from "./components/Header/Header";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Media from "./pages/Media/Media";
import ActingResume from "./pages/ActingResume/ActingResume";
import CommercialReel from "./pages/CommercialReel/CommercialReel";
import ScrollingTextBar from "./components/ScrollingTextBar/ScrollingTextBar";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import "normalize.css";
import './App.css';

const pageTransition = {
  in: {
    opacity: 1,
    transition: {
      duration: 0.5
    }
  },
  out: {
    opacity: 0,
    transition: {
      duration: 0.5
    }
  }
};

const routes = [
  { path: "/", element: Home },
  { path: "/about", element: About },
  { path: "/contact", element: Contact },
  { path: "/media", element: Media },
  { path: "/acting-resume", element: ActingResume },
  { path: "/commercial-reel", element: CommercialReel }
];

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation(); 

  return (
    <>
      <AnimatePresence mode="wait">
        <ScrollToTop />
        <Header />
        <Routes location={location} key={location.pathname}>
          {routes.map(({ path, element: Element }) => (
            <Route
              key={path}
              path={path}
              element={
                <motion.div initial="out" animate="in" exit="out" variants={pageTransition}>
                  {typeof Element === "function" ? <Element /> : null}
                </motion.div>
              }
            />
          ))}
        </Routes>
        </AnimatePresence>
      <ScrollingTextBar />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}

export default App;
